import { c as _c } from "react/compiler-runtime";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { AnimatePresence, motion } from "framer-motion";
import { useId } from "react";
interface DateAccordionProps {
  readonly title: React.ReactNode;
  readonly isExpanded: boolean;
  readonly onToggle: () => void;
  readonly collapsedContent?: React.ReactNode | undefined;
  readonly children: React.ReactNode;
  readonly showChevron?: boolean | undefined;
}
export default function DateAccordion(t0) {
  const $ = _c(36);
  const {
    title,
    isExpanded,
    onToggle,
    collapsedContent,
    children,
    showChevron: t1
  } = t0;
  const showChevron = t1 === undefined ? true : t1;
  const contentId = useId();
  let t2;
  let t3;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      opacity: 0,
      y: 10
    };
    t3 = {
      opacity: 1,
      y: 0
    };
    t4 = {
      duration: 0.4
    };
    $[0] = t2;
    $[1] = t3;
    $[2] = t4;
  } else {
    t2 = $[0];
    t3 = $[1];
    t4 = $[2];
  }
  let t5;
  if ($[3] !== isExpanded) {
    t5 = isExpanded ? {
      rotate: 0
    } : {
      rotate: 180
    };
    $[3] = isExpanded;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      duration: 0.3
    };
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const t7 = `tw-size-4 ${showChevron ? "tw-text-primary-400" : "tw-text-iron-700"} tw-transition-all tw-duration-200`;
  let t8;
  if ($[6] !== t7) {
    t8 = <FontAwesomeIcon icon={faChevronDown} className={t7} />;
    $[6] = t7;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] !== t5 || $[9] !== t8) {
    t9 = <motion.div animate={t5} transition={t6} className="tw-p-1.5 tw-rounded-full desktop-hover:hover:tw-bg-iron-700/30 tw-transition-colors tw-duration-200">{t8}</motion.div>;
    $[8] = t5;
    $[9] = t8;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== title) {
    t10 = <p className="tw-mb-0 tw-text-base tw-font-semibold tw-text-iron-300">{title}</p>;
    $[11] = title;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== t10 || $[14] !== t9) {
    t11 = <div className="tw-flex tw-items-center tw-gap-x-3">{t9}{t10}</div>;
    $[13] = t10;
    $[14] = t9;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== collapsedContent || $[17] !== isExpanded) {
    t12 = !isExpanded && collapsedContent && <div className="tw-opacity-80 hover:tw-opacity-100 tw-transition-opacity tw-duration-200">{collapsedContent}</div>;
    $[16] = collapsedContent;
    $[17] = isExpanded;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== t11 || $[20] !== t12) {
    t13 = <div className="tw-flex tw-items-center tw-justify-between tw-w-full">{t11}{t12}</div>;
    $[19] = t11;
    $[20] = t12;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== contentId || $[23] !== isExpanded || $[24] !== onToggle || $[25] !== t13) {
    t14 = <button type="button" onClick={onToggle} aria-expanded={isExpanded} aria-controls={contentId} className="tw-w-full tw-px-5 tw-h-16 tw-flex tw-items-center tw-justify-between tw-rounded-xl tw-bg-transparent tw-border-0 tw-text-left tw-cursor-pointer desktop-hover:hover:tw-bg-iron-800/50 tw-transition-colors tw-duration-200 focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-primary-400">{t13}</button>;
    $[22] = contentId;
    $[23] = isExpanded;
    $[24] = onToggle;
    $[25] = t13;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] !== children || $[28] !== contentId || $[29] !== isExpanded) {
    t15 = isExpanded && <motion.div initial={{
      height: 0,
      opacity: 0
    }} animate={{
      height: "auto",
      opacity: 1
    }} exit={{
      height: 0,
      opacity: 0
    }} transition={{
      duration: 0.3,
      ease: [0.04, 0.62, 0.23, 0.98]
    }} id={contentId}>{children}</motion.div>;
    $[27] = children;
    $[28] = contentId;
    $[29] = isExpanded;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== t15) {
    t16 = <AnimatePresence>{t15}</AnimatePresence>;
    $[31] = t15;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== t14 || $[34] !== t16) {
    t17 = <motion.div className="tw-bg-iron-900 tw-rounded-xl tw-ring-1 tw-ring-iron-700/50 tw-shadow-sm" initial={t2} animate={t3} transition={t4}>{t14}{t16}</motion.div>;
    $[33] = t14;
    $[34] = t16;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  return t17;
}